import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getIsFetching, getMarketPpisAll } from '../selectors';
import { fetchPpisRelatedToMarketPpsi } from '../actions';

const usePpisRelatedToMarket = (marketCode, ppsiId) => {
  const [notStartedFetching, setNotStartedFetching] = useState(true);
  const dispatch = useDispatch();
  const isFetchingPpis = useSelector(getIsFetching);
  const marketPpis = useSelector(getMarketPpisAll);
  const isFetching = notStartedFetching ? true : isFetchingPpis;

  useEffect(() => {
    dispatch(fetchPpisRelatedToMarketPpsi(marketCode, ppsiId));
    setNotStartedFetching(false);
  }, [dispatch, ppsiId]);

  return [isFetching, marketPpis];
};

export default usePpisRelatedToMarket;
